module.exports = __webpack_public_path__ + "static/media/IntroMessageStudentPattern.e5779236.svg";